export default __webpack_public_path__ + "static/media/Azimuto.e7467e04.png";